module.exports = __webpack_public_path__ + "static/img/dashboard-preview.5a33799.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-preview.png
// module id = GfU3
// module chunks = 1